/* TrueRim · Equipment / supply / default product page (sections/truerim-equipment-page.liquid, Phase 5 2026-10-21).
   Option pills -> hidden variant id + price + stock + SKU + photo + ?variant= in the URL; photo thumbnails; quantity
   stepper; the phone buy bar (slides in when the buy row is off screen, its + button submits the real form so the
   theme's product-form.js adds to cart and opens the drawer). No cart calls of its own. Without JS: the first available
   variant, quantity 1 and a normal form post. commerce/SPEC.md §5. */
(function () {
  function boot(root) {
    if (!root || root.getAttribute('data-treq-init')) return;
    root.setAttribute('data-treq-init', '1');
    var stage = root.querySelector('[data-treq-stage]');
    function show(src, srcset, alt) {
      if (!stage || !src) return;
      stage.src = src;
      if (srcset) stage.srcset = srcset; else stage.removeAttribute('srcset');
      if (alt) stage.alt = alt;
      root.querySelectorAll('[data-treq-thumb]').forEach(function (t) {
        var on = t.getAttribute('data-src') === src;
        t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    root.querySelectorAll('[data-treq-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-alt')); });
    });

    var idInput = root.querySelector('[data-treq-id]');
    var priceEl = root.querySelector('[data-treq-price]');
    var wasEl = root.querySelector('[data-treq-was]');
    var skuEl = root.querySelector('[data-treq-sku]');
    var stockEl = root.querySelector('[data-treq-stock]');
    var atc = root.querySelector('[data-treq-atc]');
    var atcLabel = root.querySelector('[data-treq-atc-label]');
    var bar = document.querySelector('[data-treq-bar]');
    var barPrice = bar && bar.querySelector('[data-treq-bar-price]');
    var barAdd = bar && bar.querySelector('[data-treq-bar-add]');
    root.querySelectorAll('[data-treq-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-treq-size]').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
        var ok = b.getAttribute('data-available') === 'true';
        if (idInput) idInput.value = b.getAttribute('data-variant-id');
        if (priceEl) priceEl.textContent = b.getAttribute('data-price');
        if (barPrice) barPrice.textContent = b.getAttribute('data-price');
        if (wasEl) { var w = b.getAttribute('data-was'); wasEl.textContent = w || ''; wasEl.hidden = !w; }
        if (skuEl) { var s = b.getAttribute('data-sku'); var lab = skuEl.textContent.split(' ')[0]; skuEl.textContent = lab + ' ' + (s || ''); skuEl.hidden = !s; }
        if (atc) atc.disabled = !ok;
        if (barAdd) barAdd.disabled = !ok;
        if (atcLabel) atcLabel.textContent = ok ? atcLabel.getAttribute('data-add') : atcLabel.getAttribute('data-out');
        if (stockEl && root.getAttribute('data-treq-stock-in') == null) root.setAttribute('data-treq-stock-in', stockEl.textContent);
        if (stockEl) stockEl.textContent = ok ? root.getAttribute('data-treq-stock-in') : (atcLabel ? atcLabel.getAttribute('data-out') : '');
        var dot = stockEl && stockEl.previousElementSibling;
        if (dot && dot.classList.contains('treq-dot')) dot.classList.toggle('treq-dot--out', !ok);
        if (b.getAttribute('data-src')) show(b.getAttribute('data-src'), null, b.getAttribute('data-alt'));
        try { var u = new URL(location.href); u.searchParams.set('variant', b.getAttribute('data-variant-id')); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      });
    });

    var qty = root.querySelector('.treq-qty__i');
    var minus = root.querySelector('[data-treq-minus]'), plus = root.querySelector('[data-treq-plus]');
    function val() { var v = parseInt(qty.value, 10); return isNaN(v) || v < 1 ? 1 : v; }
    if (qty && minus) minus.addEventListener('click', function () { qty.value = Math.max(1, val() - 1); });
    if (qty && plus) plus.addEventListener('click', function () { qty.value = val() + 1; });
    if (qty) qty.addEventListener('change', function () { qty.value = val(); });

    if (barAdd && atc) barAdd.addEventListener('click', function () { if (!atc.disabled) atc.click(); });

    /* phone buy bar: in once the buy row (or the quote card) has scrolled up out of view, out again while the quote form
       is on screen. A passive scroll listener (rAF-throttled): an IntersectionObserver alone misses a jump from below the
       fold to above it (no intersection change in between). */
    if (bar && window.matchMedia) {
      var target = root.querySelector('[data-treq-buyrow]') || root.querySelector('.treq-quote-card');
      var form = root.querySelector('.treq-qband');
      var phone = window.matchMedia('(max-width: 849px)');
      var t = null, ticking = false;
      function update() {
        ticking = false;
        var vh = window.innerHeight, f = form ? form.getBoundingClientRect() : null;
        var on = phone.matches && target && target.getBoundingClientRect().bottom < 0 && !(f && f.top < vh && f.bottom > 0);
        clearTimeout(t);
        if (on) { if (bar.hidden) { bar.hidden = false; void bar.offsetWidth; } bar.classList.add('is-in'); }
        else if (!bar.hidden) { bar.classList.remove('is-in'); t = setTimeout(function () { bar.hidden = true; }, 400); }
      }
      function req() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      if (target) {
        window.addEventListener('scroll', req, { passive: true });
        window.addEventListener('resize', req);
        if (phone.addEventListener) phone.addEventListener('change', req);
        req();
      }
    }
  }
  function all() { document.querySelectorAll('[data-treq]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
